import instance from "../utils/network";

export interface YoutubeLiveDto {
  id: number;
  name: string;
  link: string;
  isLive: boolean;
  order: number;
  pubId: number;
  imageUrl: string;
}

export interface PubYoutubeLiveResponse {
  pubId: number;
  youtubeLiveList: YoutubeLiveDto[];
}

export function getYoutubeLiveList(
  pubIds: number[]
): Promise<PubYoutubeLiveResponse[]> {
  return instance.post("/nest/youtube-live/list", { pubIds });
}
